import { useEffect } from 'react'

import { queryClient } from '@space-shell/config/request'

/**
 * Array of query keys that should be preserved from cache reset.
 * @type {string[]}
 */
const KEYS_TO_KEEP: string[] = ['membershipInfo']

/**
 * Custom hook that listens for the 'club:clear_cache' event and resets
 * the Tanstack Query cache for all queries except those with keys specified in KEYS_TO_KEEP.
 *
 * When the event is triggered, the hook iterates over all cached queries and resets
 * them to their initial state, unless their query key matches one of the keys in KEYS_TO_KEEP.
 *
 * @returns {void}
 */
export function useClearCache(): void {
  useEffect(() => {
    /**
     * Event listener function that resets cached queries excluding those specified in KEYS_TO_KEEP.
     *
     * @returns {void}
     */
    function listener(): void {
      queryClient
        .getQueryCache()
        .getAll()
        .forEach((query) => {
          if (!query.queryKey.some((key) => KEYS_TO_KEEP.includes(String(key)))) {
            queryClient.resetQueries(query.queryKey, { exact: true })
          }
        })
    }

    window.addEventListener('club:clear_cache', listener)

    return () => {
      window.removeEventListener('club:clear_cache', listener)
    }
  }, [])
}
